import React, { useRef } from 'react';
import {
  TextField,
  ReferenceField,
  NumberField,
  ListBase,
  ListToolbar,
  Pagination,
  useRefresh,
  Datagrid,
} from 'react-admin';

import { Card, Box } from '@material-ui/core';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import moment from 'moment';

import DialogoDeleteResource from './DialogoDeletar';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { PERMISSAO_TELA_CONFERENCIAS_FREEZERS_LISTAR } from '../../utils/dadosTelas';
import Actions from './ActionsList';
import Dialogo from './DialogoCreateEdit';
import DialogoCriarListaConferenciasHoje from './DialogoCriarListaConferenciasHoje';
import DateInputMobills from './Inputs/DateInputMobills';
import StatusField from './StatusField';

function formatHorario(data) {
  return moment(new Date(data)).format('DD/MM/YYYYY - HH:mm');
}

const PostPanel = ({ record }) => (
  <div>
    <div>
      <h3>Manhã</h3>
      <div>
        <div>
          <span style={{ marginRight: '20px' }}>Horário:</span>
          <span>{formatHorario(record.horario_manha)}</span>
        </div>
      </div>
    </div>
    <div style={{ marginTop: '20px' }}>
      <h3>Tarde</h3>
      <div>
        <div>
          <span style={{ marginRight: '20px' }}>Horário:</span>
          <span>{formatHorario(record.horario_tarde)}</span>
        </div>
      </div>
    </div>
  </div>
);

const MyList = ({ ...props }) => {
  const refresh = useRefresh();
  const refDialogoCompra = useRef(null);
  const refDialogoDeleteResource = useRef(null);
  const refDialogoCriarListaConferenciasHoje = useRef(null);

  function handleCriar() {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleCreate();
    }
  }
  function handleEdit({ id }) {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleEdit(id);
    }
  }
  function deleteHundle(record) {
    if (refDialogoDeleteResource.current)
      refDialogoDeleteResource.current.handleOpen(record);
  }

  function handleClose() {
    refresh();
  }

  function handleCriarConferencias() {
    if (refDialogoCriarListaConferenciasHoje.current) {
      refDialogoCriarListaConferenciasHoje.current.handleOpen();
    }
  }

  return (
    <>
      <ListToolbar
        actions={
          <Actions
            handleCriar={handleCriar}
            handleCriarConferencias={handleCriarConferencias}
            {...props}
          />
        }
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Box flex={1} margin="0px 0 20px">
          <DateInputMobills />
        </Box>
        <Datagrid {...props}>
          <StatusField source="status_manha" label="Manhã" sortable={false} />
          <StatusField source="status_tarde" label="Tarde" sortable={false} />
          <ReferenceField
            label="Freezer"
            source="equipamento_freezer_id"
            reference="equipamentos_freezer"
            sortable={false}
            linkType={false}
          >
            <TextField source="nome" />
          </ReferenceField>
          <NumberField
            source="temperatura_manha"
            locales="pt-BR"
            options={{
              maximumFractionDigits: 1,
              minimumFractionDigits: 1,
              currency: 'BRL',
            }}
            label="Temperatura Manhã (°C)"
          />
          <NumberField
            source="temperatura_tarde"
            locales="pt-BR"
            options={{
              maximumFractionDigits: 1,
              minimumFractionDigits: 1,
              currency: 'BRL',
            }}
            label="Temperatura Tarde (°C)"
          />
          <ReferenceField
            label="Usuário Manhã"
            source="user_id_1"
            reference="users"
            sortable={false}
            linkType={false}
          >
            <TextField source="username" />
          </ReferenceField>
          <ReferenceField
            label="Usuário Tarde"
            source="user_id_2"
            reference="users"
            sortable={false}
            linkType={false}
          >
            <TextField source="username" />
          </ReferenceField>
          <ActionsField
            source="lalala"
            textAlign="right"
            label="Ações"
            sortable={false}
            /* handleEdit={handleEdit}
            handleShow={handleShow} */
            actions={[
              {
                key: 'editar',
                title: 'Editar',
                icon: <EditOutlinedIcon />,
                onClick: (rec) => handleEdit(rec),
                show: () => true,
                disabled: () => false,
              },
            ]}
          />
        </Datagrid>
        <TransacoesPagination />
      </Card>
      <Dialogo ref={refDialogoCompra} handleClose={handleClose} />
      <DialogoDeleteResource ref={refDialogoDeleteResource} />
      <DialogoCriarListaConferenciasHoje
        ref={refDialogoCriarListaConferenciasHoje}
      />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const DIA_ATUAL = new Date().getDate();
const MES_ATUAL = new Date().getMonth();
const ANO_ATUAL = new Date().getFullYear();

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_CONFERENCIAS_FREEZERS_LISTAR}>
    <ContainerMyList
      {...props}
      expand={<PostPanel />}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      title="Conf. Temperaturas Freezers"
      filterDefaultValues={{
        periodo: { dia: DIA_ATUAL, mes: MES_ATUAL, ano: ANO_ATUAL },
      }}
    />
  </ProtegerPagina>
);

export default List2;
